import { render, staticRenderFns } from "./NewProducts.vue?vue&type=template&id=44248945&scoped=true&"
import script from "./NewProducts.vue?vue&type=script&lang=ts&"
export * from "./NewProducts.vue?vue&type=script&lang=ts&"
import style0 from "./NewProducts.vue?vue&type=style&index=0&id=44248945&prod&lang=scss&"
import style1 from "./NewProducts.vue?vue&type=style&index=1&id=44248945&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44248945",
  null
  
)

export default component.exports